import React, { useRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";

import SearchField from "@/shared/components/SearchField/SearchField";

import styles from "./Header.module.scss";

const HeaderForm = ({
  className,
  initialValue,
  beforeInput,
  afterInput,
  onSearch,
  searchPlaceholder,
  onClearSearchQuery,
  onChange,
}) => {
  const { t } = useTranslation();

  const refSearchInput = useRef();

  const handleSearch = (query) => {
    if (refSearchInput.current) {
      refSearchInput.current.blur();
    }

    // trim - 3839.
    // Is here, bcz Reader Search and Global search use this component.
    // But may be need to move trim logic to another place.
    onSearch(query.trim());
  };

  const handleCloseIconClick = () => {
    refSearchInput.current?.focus(); // UX

    if (onClearSearchQuery) {
      onClearSearchQuery();
    }
  };

  return (
    <SearchField
      className={classnames(styles["header-form"], className)}
      ref={refSearchInput}
      slotAfter={afterInput}
      required
      slotBefore={beforeInput}
      value={initialValue}
      onSearch={handleSearch}
      onClear={handleCloseIconClick}
      onChange={onChange}
      placeholder={searchPlaceholder}
    />
  );
};

HeaderForm.propTypes = {
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  initialValue: PropTypes.string,
  afterInput: PropTypes.node,
  beforeInput: PropTypes.node,
  onSearch: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  onClearSearchQuery: PropTypes.func,
  onChange: PropTypes.func,
};

export default HeaderForm;
